export default __webpack_public_path__ + "static/media/ic_right_caret_primary.e44ba282.svg";